/**
 * Connexion au site de gestion : même compte que le site public (courriel ou nom d'utilisateur).
 */
import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { login } from '@web/features/auth/services/authApi'
import { setTokens, useIsAuthenticated } from '@web/features/auth/utils/tokenStorage'
import brandLogo from '@web/img/Logo-Refuge-500.png'
import { publicSiteUrl } from '../utils/links'

export function LoginPage() {
  const { t } = useTranslation('gestion')
  const authed = useIsAuthenticated()
  const navigate = useNavigate()
  const location = useLocation()
  const from = (location.state as { from?: string } | null)?.from || '/'
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (authed) return <Navigate to={from} replace />

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      setTokens(await login({ email: identifier.trim(), password }))
      navigate(from, { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : t('connexion.erreur'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="g-login">
      <form className="g-login__card" onSubmit={submit}>
        <img src={brandLogo} alt="" className="g-login__logo" />
        <h1 className="g-login__title">{t('connexion.titre')}</h1>
        <p className="g-login__intro">{t('connexion.intro')}</p>
        <label className="g-field">
          <span className="g-field__label">{t('connexion.identifiant')}</span>
          <input
            className="g-input"
            type="text"
            autoComplete="username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        </label>
        <label className="g-field">
          <span className="g-field__label">{t('connexion.mot_de_passe')}</span>
          <input
            className="g-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && (
          <p className="g-alert g-alert--error" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="btn btn--primary g-login__submit" disabled={busy}>
          {busy ? t('connexion.en_cours') : t('connexion.se_connecter')}
        </button>
        <div className="g-login__links">
          <a href={publicSiteUrl('/forgot-password')}>{t('connexion.oublie')}</a>
          <a href={publicSiteUrl('/')}>{t('connexion.retour_site')}</a>
        </div>
      </form>
    </main>
  )
}
